/**
 * Returns whether selection is full document, partial selection or none.
 */
export var getContextSelectionScope = function getContextSelectionScope(_ref) {
  var _node$content;
  var editorView = _ref.editorView,
    slice = _ref.slice,
    node = _ref.node;
  var hasContent = node ? (((_node$content = node.content) === null || _node$content === void 0 ? void 0 : _node$content.size) || 0) > 2 : slice ? slice.size >= 1 : false;
  if (hasContent) {
    var _slice$content, _slice$content$eq, _node$eq;
    if (slice !== null && slice !== void 0 && (_slice$content = slice.content) !== null && _slice$content !== void 0 && (_slice$content$eq = _slice$content.eq) !== null && _slice$content$eq !== void 0 && _slice$content$eq.call(_slice$content, editorView.state.doc.content) || node !== null && node !== void 0 && (_node$eq = node.eq) !== null && _node$eq !== void 0 && _node$eq.call(node, editorView.state.doc)) {
      return 'fullDocument';
    } else {
      return 'partialSelection';
    }
  }
  return 'none';
};